var SiteConfig = {
  LOGIN_SYSTEM_NAME: "Racing Manager",
  LOGIN_PHONE_LINE: 1123,
  VOID_REASON: 2,
  SYSTEM_ID: "D",
  USER_ACCESS_SVC: "useraccesssvc",
  RACING_MGMT_SVC: "racingmgmtsvc",
  RACING_INTEGRATION_SVC: "racingintegrationsvc",
  RACING_SCORING_SVC: "racingscoringsvc",
  RACING_TICKET_VALIDATOR_SVC: "racingticketvalidatorsvc",
  LOG_SVC: "logsvc",
};

export const TRACK_TYPES = { Thoroughbred: 1, Harness: 2, Greyhounds: 4 };

export default SiteConfig;
